module.exports = __webpack_public_path__ + "img/13.746fa4a7.jpg";